import React from 'react';
import '../css/Intro.css';

const Intro: React.FC = () => {
    return (
        <div className="intro">
            <div className="intro-content">
                <div className="intro-block">
                    <div className="intro-title">
                        <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Golden Cross</div>
                        <div style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>골든 크로스</div>
                        <br />
                        ──────
                        <br />
                    </div>
                    <div className="intro-title">
                        <div style={{ display: 'inline-block', fontSize: '1.5rem' }}>"골든크로스"</div>는 단순한 금융
                        용어를 넘어,
                        <br /> 새로운 성장과 기회를 상징하는 이름입니다.
                    </div>
                    <div className="intro-description">
                        <div>
                            ㈜ 골든크로스는 글로벌 트레이딩 업계에서 빠르게 성장하고 있는
                            <br />
                            Ai딥러닝 트레이딩 프로그램 개발사입니다.{' '}
                        </div>
                    </div>
                </div>
                <div
                    className="intro-img-block"
                    style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL + '/intro.jpg'})`,
                        backgroundColor: `rgba(0, 0, 0, 0.5)`,
                        backgroundBlendMode: 'multiply',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundOrigin: 'border-box',
                        backgroundPosition: 'center',
                        overflow: 'hidden',
                    }}
                ></div>
            </div>
        </div>
    );
};

export default Intro;
